import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Archive = lazy(() => import('MentalHealth/pages/archive'))
const ActiveChat = lazy(() => import('MentalHealth/pages/ActiveChats'))
const Dashboard = lazy(() => import('MentalHealth/pages/Dashboard'))
const Doctors = lazy(() => import('MentalHealth/pages/Doctors'))
const Counsellors = lazy(() => import('MentalHealth/pages/Counsellors/index'))
const Calendar = lazy(() =>
  import('MentalHealth/pages/Calendar/CounselorCalendar/index'),
)
const CannedMessages = lazy(() =>
  import('MentalHealth/pages/CannedMessages/index'),
)
const Patient = lazy(() => import('MentalHealth/pages/Patient/index'))
const UserProfile = lazy(() => import('MentalHealth/pages/Profile/index'))
const Logs = lazy(() => import('pages/PatientLogs/Logs'))
const Settings = lazy(() => import('pages/settings'))


export const counselorRoutes = [
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/calendar',
    element: <Calendar />,
  },
  {
    path: '/active-chats',
    element: <ActiveChat />,
  },
  {
    path: '/doctors',
    element: <Doctors />,
  },
  {
    path: '/profile',
    element: <UserProfile />,
  },
  {
    path: '/archive-chats',
    element: <Archive />,
  },
  {
    path: '/settings',
    element: <Settings />,
  },
  {
    path: '/patient/:patientId',
    element: <Patient />,
  },
  {
    path: '/logs/patients/:patientID',
    element: <Logs />,
  },
  {
    path: '/logs/doctors/:doctorID',
    element: <Logs />,
  },
  {
    path: '*',
    element: <Navigate to="/dashboard" replace />,
  },
]
